import Button from 'components/Button';
import IconCard from 'components/IconCards';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';

interface PayButtonProps {
    isLoading: boolean;
    onClick: () => void;
}

const PayButton: FC<PayButtonProps> = ({isLoading, onClick}) => {
    const {t} = useTranslation('Portal');

    return (
        <Button
            aria-label="pay"
            className="w-full"
            isLoading={isLoading}
            kind="secondary"
            onClick={onClick}
            size="base"
        >
            <div className="flex items-center justify-center gap-1">
                <div className="mr-1">
                    {t('clientInboxItem.payPanel.button')}
                </div>
                <IconCard icon="show-all" />
            </div>
        </Button>
    );
};

export default PayButton;
